import React, { useState } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const cardData = [
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1750715878/image_sppdiw.png",
    date: "June  03, 2025",
    title: "Stay Ahead with Intelligent Disease Surveillance",
    description: "Scanning livestock diseases, Diagnosis, treatment and management",
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1750715877/image-1_rliqwg.png",
    date: "May  10, 2025",
    title: "On-Demand Digital Agronomic Services for Precision Agriculture",
    description: "Scanning livestock diseases, Diagnosis, treatment and management",
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1751125891/WhatsApp_Image_2025-06-28_at_2.52.47_PM_ykemma.jpg",
    date: "January 15, 2025",
    title: "Automated environmental control systems",
    description: "Sensor-based monitoring to optimize the living conditions of chickens and improve overall farm efficiency.",
  },
];

const settings = {
  infinite: true,
  slidesToShow: 2.5,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  centerMode: false,      // ❗ Prevents centering, which was causing the cut
  initialSlide: 0,        // ❗ Ensures the first slide is fully visible
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerMode: false, // Keep center mode off on smaller devices too
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.4,
        centerMode: false,
      },
    },
  ],
};


const CardSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  return (
    <section className="relative bg-[#152C24] md:pr-20  md:pl-[120px] px-4 md:pb-3  md:mb-0 -mt-4">
      <h2 className="text-[10px] md:text-[40px] font-bold text-[#FDBD26] md:pt-6 pt-2">
      Stay informed with insights and innovations
      </h2>

      <div className="flex flex-row items-center justify-between md:mt-1" style={{ lineHeight: "1.23" }}>
        <div className="flex-1 overflow-hidden">
          {/* Desktop */}
          <div className="hidden md:block">
            {isExpanded ? (
              <p className="text-[32px] text-white mb-4 font-normal animate-fadeIn">
                The Farmnet mobile app offers farmers innovative solutions such as real-time weather alerts, expert farming tips, digital marketplace access, crop management tools, and direct communication with buyers. These features help farmers boost productivity, reduce risks, and improve income through smarter, data-driven farming.
              </p>
            ) : (
              <p className="text-[32px] text-white mb-4 font-normal animate-fadeIn">
                Farmnet mobile app empowers farmers with real-time insights and cutting-edge agricultural innovations...
              </p>
            )}
          </div>

          {/* Mobile */}
          <div className="md:hidden block">
            {isExpanded ? (
              <p className="text-[8px] text-white animate-fadeIn">
                The Farmnet app enhances productivity by giving farmers expert advice, weather updates, and access to digital tools.
              </p>
            ) : (
              <p className="text-[8px] text-white animate-fadeIn">
                Farmnet helps with weather updates, expert farming advice & market info...
              </p>
            )}
          </div>
        </div>

        <button onClick={toggleExpand} className="focus:outline-none flex-shrink-0">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750715512/Expand_down_rzrdrt.png"
            alt="Expand"
            className={`md:w-[34px] md:h-[34px] h-[10px] w-[10px] transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`}
          />
        </button>
      </div>

      {/* Slick Slider */}
      <div className="mt-4">
        <Slider {...settings}>
          {cardData.map((card, index) => (
            <div key={index}>

            <div className="card-inner mx-1 md:mx-2 md:w-[475px] rounded-[2px] md:rounded-md ">
  <div className="w-full h-[90px] md:h-[250px] overflow-hidden rounded-[2px] md:rounded-md">
    <img
      src={card.image}
      alt={`Card ${index + 1}`}
      className="w-full h-full object-cover"
    />
  </div>
  
  <div className="md:pt-3 pt-1 bg-[#2E453D] md:px-4 px-1 md:h-[80px] h-[30px]  rounded-b-[5px]">
    <p className="text-[5px] md:text-[16px] text-white font-normal md:mb-1">
      {card.date}
    </p>
    <p className="text-[6px] md:text-[18px] text-white font-bold md:mb-3  leading-snug" style={{ lineHeight: "1.10" }}>
      {card.title}
    </p>

  </div>
</div>

</div>

          ))}
        </Slider>
      </div>
{/* Floating See More Button */}

<div className="flex justify-end items-end md:mt-8 mt-2 md:mr-0 mr-2">

     <a
          href="/InnovationMain"
          className="md:w-[220px] w-[80px] h-[15px] md:h-[50px] flex items-center justify-center rounded-[2px] md:rounded-[8px] font-bold text-[6px] md:text-[20px] text-white shadow-xl"
          style={{
            background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          <span className="flex-1 text-center">Go To</span>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756410811/Expand_right_1_bpdsxb.png"
            alt="arrow"
            className="md:w-[23px] w-[12px] h-[14px] md:h-[21px] mr-1 md:mr-4"
          />
        </a>
</div>

      {/* Fade-in Animation */}
      <style jsx global>{`
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .animate-fadeIn {
    animation: fadeIn 0.3s ease-in-out;
  }

  /* Fix spacing between slick slides */
  .slide-spacing {
    padding: 0 10px;
  }

  .slick-slide > div {
    display: flex;
    justify-content: center;
  }
`}</style>

    </section>
  );
};

export default CardSection;
